import { AppState, AppStateContext } from 'components/App'
import { useContext } from 'react'
import { SetStateType } from 'types'

export default function useAppState(): [AppState, SetStateType<AppState>] {
  const [appState, setAppState] = useContext(AppStateContext)
  return [appState, setAppState]
}
